import React, { FC } from "react";
import { IAdvantageCard } from "./types";
import { SafeHTML } from "src/components/SafeHTML";

interface Props extends IAdvantageCard {}

export const AdvantageCard: FC<Props> = ({
  title,
  description,
  icon: Icon,
}) => (
  <div className="flex flex-col justify-center gap-3 w-full h-full p-5.5 odd:bg-blue-base odd:text-green-base even:text-white-base even:bg-green-base rounded-2xl md:px-8 md:py-6 4xl:gap-5 4xl:py-11.25 4xl:px-15">
    <Icon className="w-9 h-9 md:w-10 md:h-10 4xl:w-12.5 4xl:h-12.5" />
    <h4 className="text-lg 4xl:text-24">{title}</h4>
    <SafeHTML
      html={description}
      className="text-xs 4xl:text-base"
    />
  </div>
);
